<template>
  <div>
    <p>Welcome Customer</p>
  </div>
</template>

<script>
export default {
  name: "CustomerDashboard",
};
</script>

<style></style>
